<h2 mat-dialog-title>Confirm</h2>
<mat-dialog-content>
    Are you sure you want to log out?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="logout()">Yes</button>
</mat-dialog-actions>